export const DS_CARD_CLASSES = {
  Root: "ds-card",
  Header: "ds-card__header",
  Icon: "ds-card__icon",
  Heading: "ds-card__heading",
  Title: "ds-card__title",
  Subtitle: "ds-card__subtitle",
  Suffix: "ds-card__suffix",
  Actions: "ds-card__actions",
  Toggle: "ds-card__toggle",
  Content: "ds-card__content",
} as const;
